import { makeAutoObservable } from 'mobx';

class Store {
  constructor() {
    makeAutoObservable(this);
  }
  PAGE_SOURCE = 'page_source';
  SOURCE_VAL = 'marketing';

  // 是否来自营销云 page_source=marketing
  get isMarketingCloud() {
    const inIframe = window.self !== window.top;
    console.log('inIframe', inIframe);
    const urlParams = new URLSearchParams(window.location.search);
    const hasMarketingSource =
      urlParams.get(this.PAGE_SOURCE) === this.SOURCE_VAL;
    console.log('hasMarketingSource', hasMarketingSource);
    return inIframe && hasMarketingSource;
  }
  marketingLongin = () => {
    console.log('marketingLongin');
    window.parent.postMessage({ type: 'login' }, '*');
  };
  pageReady = () => {
    console.log('pageReady');
    window.parent.postMessage({ type: 'ready' }, '*');
  };
  pageChange = route => {
    window.parent.postMessage({ type: 'change', data: { route } }, '*');
  };
}
const MarketingStore = new Store();
export default MarketingStore;
